import Vue from 'vue'
import Router from 'vue-router'
import $config from '../config/config'
import Index from '@/components/index/index'
import wxuserUtil from '@/common/wxuserUtil'

import active from './active'   //活动
import clients from './clients'  //客户
import curriculums from './curriculum' //课程
import reports     from  './report'    //报表
/**
 *  企业微信授权
 */
import config from '../config/config';
import Wxchart from '../common/wxChart';

Vue.use(Router)

let router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta: {
        title: "首页",
        keepAlive: true
      }
    },
    ...active,
    ...clients,
    ...curriculums,
    ...reports
  ]
});

wxuserUtil.loadWxAuth(router);

if(config.mockUser && !config.wxauth){
  wxuserUtil.clearCache();
  wxuserUtil.queryUser();
}


const setTitle = (to, from, next) => {

  to.meta.title ? document.title = to.meta.title : document.title = $config.nameTitle;

  // if (window.location.href.indexOf('code') != -1) {
  // } else {
    // if (config.wxauth) {
    //   new Wxchart();
    // }
  // }
  next()
};


//设置title
router.beforeEach(setTitle);




export default router;



// WEBPACK FOOTER //
// ./src/router/index.js